import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations/translations';
import './Skills.css';

const Skills = () => {
  const { currentLanguage } = useLanguage();
  const t = translations[currentLanguage];

  const skillCategories = [
    {
      title: t.skills.specialization.title,
      skills: [
        { name: t.skills.specialization.existential, level: 95 },
        { name: t.skills.specialization.trauma, level: 90 },
        { name: t.skills.specialization.attachment, level: 88 },
        { name: t.skills.specialization.clinical, level: 92 },
        { name: t.skills.specialization.crisis, level: 85 },
        { name: t.skills.specialization.sexology, level: 80 }
      ]
    },
    {
      title: t.skills.workWith.title,
      skills: [
        { name: t.skills.workWith.identity, level: 95 },
        { name: t.skills.workWith.personalCrisis, level: 90 },
        { name: t.skills.workWith.relationships, level: 92 },
        { name: t.skills.workWith.loss, level: 88 },
        { name: t.skills.workWith.anxiety, level: 90 },
        { name: t.skills.workWith.family, level: 85 }
      ]
    },
    {
      title: t.skills.methods.title,
      skills: [
        { name: t.skills.methods.gestalt, level: 95 },
        { name: t.skills.methods.existential, level: 90 },
        { name: t.skills.methods.dialogue, level: 92 },
        { name: t.skills.methods.emotions, level: 88 },
        { name: t.skills.methods.supervision, level: 85 },
        { name: t.skills.methods.ethics, level: 100 }
      ]
    }
  ];

  return (
    <section id="skills" className="skills">
      <div className="container">
        <h2 className="section-title">{t.skills.title}</h2>
        <p className="section-subtitle">
          {t.skills.subtitle}
        </p>
        
        <div className="skills-grid">
          {skillCategories.map((category, index) => (
            <div key={index} className="skill-category">
              <h3 className="category-title">{category.title}</h3>
              <div className="skills-list">
                {category.skills.map((skill, skillIndex) => (
                  <div key={skillIndex} className="skill-item">
                    <div className="skill-header">
                      <span className="skill-name">{skill.name}</span>
                      <span className="skill-percentage">{skill.level}%</span>
                    </div>
                    <div className="skill-bar">
                      <div 
                        className="skill-progress" 
                        style={{ width: `${skill.level}%` }}
                      ></div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Skills;
